// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

import 'iview/dist/styles/iview.css'
import 'swiper/dist/css/swiper.css'
import './assets/css/base.css'
import '../my-theme/index.less'
import Vue from 'vue'
import iview from 'iview'
// import $ from 'jquery'
import App from './App'
import store from './store'
import axios from './lib/axios.js'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import components from './components/' // 加载公共组件
import api from './lib/api.js'
import getDataName from './lib/getDataName.js'
import echarts from 'echarts'
import VueClipboard from 'vue-clipboard2'
import router from './router'
// import moment from 'moment'

// import './assets/theme/dark.less';

import directive from './directive/'// 加载指令

import SIdentify from './components/login/identify' // 注意引入路径

Vue.use(SIdentify)

Vue.use(iview)
Vue.use(VueAwesomeSwiper)
Vue.use(VueClipboard)
// 注册VUE全局对象
Vue.prototype.axios = axios
Vue.prototype.api = api
Vue.prototype.getDataName = getDataName
Vue.prototype.$echarts = echarts
// Vue.prototype.$moment = moment;

// 注册公共组件
Object.keys(components).forEach((key) => {
  var name = key.replace(/(\w)/, (v) => v.toUpperCase()) // 首字母大写
  Vue.component(`ws${name}`, components[key])
})

new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})

Vue.prototype.$Message.config({duration: 5})



// WEBPACK FOOTER //
// ./src/main.js